import { useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import type { Agent } from '@/types'
import { Card } from '@/components/ui/Card'
import { compileIdentity } from '@/lib/api'

export function AgentIdentityTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()
  const [soul, setSoul] = useState(agent.soul ?? '')
  const [role, setRole] = useState(agent.instructions ?? '')
  const [compiling, setCompiling] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  async function handleCompile() {
    setCompiling(true)
    setResult(null)
    try {
      const combined = `${soul}\n\n${role}`.trim()
      const res = await compileIdentity(agent.id, combined)
      setResult(`Compilado — v${res.version}${res.tag ? ` (tag ${res.tag})` : ''}`)
    } catch (e) {
      setResult(e instanceof Error ? e.message : 'Error al compilar')
    } finally {
      setCompiling(false)
    }
  }

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        <Card>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 8 }}>
            SOUL.md — quién es el agente
          </div>
          <textarea
            value={soul}
            onChange={(e) => setSoul(e.target.value)}
            placeholder="Carácter, valores, estilo de comunicación…"
            style={textareaStyle}
          />
        </Card>
        <Card>
          <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 8 }}>
            AGENTS.md — qué hace el agente
          </div>
          <textarea
            value={role}
            onChange={(e) => setRole(e.target.value)}
            placeholder="Responsabilidades, proceso, criterios de éxito…"
            style={textareaStyle}
          />
        </Card>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={handleCompile} disabled={compiling} style={compileButtonStyle}>
          {compiling ? 'Compilando…' : 'Compilar → nueva versión'}
        </button>
        {result && <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{result}</span>}
      </div>
      <p style={{ fontSize: 12, color: 'var(--text-tertiary)', marginTop: 8 }}>
        Al compilar: soul + role se combinan en <code className="mono">system_prompt</code>, se guarda en
        Supabase, y se hace commit a GitHub (SOUL.md / AGENTS.md / SYSTEM_PROMPT.md) con un tag de versión —
        pendiente de conectar al backend real.
      </p>
    </div>
  )
}

const textareaStyle: React.CSSProperties = {
  width: '100%',
  minHeight: 220,
  background: 'var(--surface-raised)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius-sm)',
  color: 'var(--text-primary)',
  fontFamily: 'var(--font-mono)',
  fontSize: 13,
  padding: 12,
  resize: 'vertical',
}

const compileButtonStyle: React.CSSProperties = {
  background: 'var(--surface-raised)',
  border: '1px solid var(--border-strong)',
  color: 'var(--text-primary)',
  borderRadius: 'var(--radius-sm)',
  padding: '8px 16px',
  fontSize: 13,
  cursor: 'pointer',
}
